<template>
  <div class="professor-create">
    <div class="container">
      <h2>创建新导师</h2>
      <form @submit.prevent="submitForm">
        <div class="form-group">
          <span style="display: block; margin-bottom: 8px;"> 姓名</span>
          <el-input
              v-model="formData.professor_name"
              style="width: 240px"
              required
              id="name"
          />
        </div>

        <div class="form-group">
          <span style="display: block; margin-bottom: 8px;"> 学校</span>
          <el-input
              v-model="formData.school_name"
              style="width: 240px"
              required
              id="school"
          />
        </div>

        <div class="form-group">
          <span style="display: block; margin-bottom: 8px;"> 院系</span>
          <el-input
              v-model="formData.college_name"
              style="width: 240px"
              required
              id="school"
          />

<!--          <label for="department">院系</label>-->
<!--          <input type="text" id="department" v-model="formData.college_name" required>-->
        </div>

        <button type="submit" class="submit-btn">提交</button>
      </form>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import BlogFooter from '@/components/BlogFooter.vue'
import axios from 'axios'
import {API_BASE_URL} from "@/config";
import { ElMessage } from 'element-plus'

export default {
  name: 'ProfessorCreate',
  components: { NavBar, BlogFooter },
  data() {
    return {
      formData: {
        professor_name: '',
        school_name: '',
        college_name: ''
      }
    }
  },
  methods: {

    async submitForm() {
      //验证token
      const token = localStorage.getItem('access.halfpanda')
      if (!token) {
        ElMessage.error('请先登录')
        return
      }
      const config = {
        headers: {
          'Authorization': token,
          'Content-Type': 'multipart/form-data'
        }
      }
      const formData = new FormData()
      formData.append('professor_name', this.formData.professor_name)
      formData.append('school_name', this.formData.school_name)
      formData.append('college_name', this.formData.college_name)

      try {
        const response = await axios.post(`${API_BASE_URL}/user/professor-create`, formData, config)

        if (response.data.code === -1) {
          ElMessage.error('导师已存在！')
          this.$router.push({
            name: 'ProfessorSearchResults',
            query: { q: this.formData.professor_name }
          })
          return
        }

        ElMessage.success('创建导师成功，学校和学院也一并创建了！')
        this.$router.push({
          name: 'ProfessorSearchResults',
          query: { q: this.formData.professor_name }
        })

      } catch (error) {
        ElMessage.error('创建失败，请稍后再试！')
      }
    }
  }
}
</script>

<style scoped>
.professor-create {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  flex: 1;
  padding: 2rem;
  max-width: 800px;
  margin: 0 auto;
  width: 100%;
}

.form-group {
  margin-bottom: 1.5rem;
}

label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.submit-btn {
  background-color: #3498db;
  color: white;
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
}

.submit-btn:hover {
  background-color: #2980b9;
}
</style>